import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Gender: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.40467 13.6149C8.31115 14.7169 8 16.3083 8 17.8607C8 18.2469 8 18.6308 8 18.9906C8 20.0991 7.09854 20.9956 5.99013 20.9901L3.99013 20.9802C2.88943 20.9748 2 20.0822 2 18.9815C2 18.0524 2 16.8232 2 15.3479C2 11.8421 5.13312 9 8.99803 9C10.9367 9 12.2327 9.8447 13.5 11C12.1831 11.4233 10.6028 12.4075 9.40467 13.6149Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M19 7C19 9.20914 17.2091 11 15 11C12.7909 11 11 9.20914 11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M11.414 5.14999C11.1509 5.7125 11.0115 6.32391 10.9909 6.94455C10.9692 7.59957 10.8956 8 10.6458 8C9.94069 8.62236 9.01445 9 8 9C5.79086 9 4 7.20914 4 5C4 2.79086 5.79086 1 8 1C9.67869 1 11.1159 2.03408 11.7092 3.5C11.8654 3.88573 11.9631 3.97576 11.414 5.14999Z"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M21.9961 17.3479C21.9961 18.3019 21.9971 19.7892 21.9981 20.9986C21.9991 22.104 21.1033 23 19.9979 23H14.998L9.99154 22.9788C8.89028 22.9742 8 22.0813 8 20.9801C8 20.0512 8 18.8224 8 17.3479C8 13.8421 11.1331 11 14.998 11C18.8629 11 21.9961 13.8421 21.9961 17.3479Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Gender;
